/**
 * Serialize a {@link Document} to a string
 * @param document
 * @returns document as string.
 */
export default function(document: Document): string {
  const serializer = new XMLSerializer();
  return serializer.serializeToString(document);
}
